import styled from 'styled-components';

export const LoadingLargeContainer = styled.div`
  [data-placeholder]::before {
    color: transparent;
    border-radius: 4px;
    content: attr(data-placeholder);
    background: ${({ theme }) => theme.palette.common.PLACEHOLDER};
  }
`;

export const LoadingLargeTitle = styled.div`
  margin: 0 0 16px;
  padding: 0;
  font-size: 24px;
  line-height: 32px;
`;

export const LoadingLargeSection = styled.div`
  margin: 0;
  padding: 0 0 32px;
`;

export const LoadingLargeSubTitle = styled.div`
  margin: 0 0 16px;
  padding: 0;
  font-size: 20px;
  line-height: 24px;
`;
